import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    checkoutElements: any;
  }
}
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.hotmart.com/lib/hotmart-checkout-elements.js';
    script.async = true;
    script.onload = () => {
      if (window.checkoutElements) {
        window.checkoutElements.init('salesFunnel').mount('#hotmart-sales-funnel');
      }
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen bg-dark w-full flex justify-center" data-id="element-0">
      {/* Mobile-first container */}
      <div className="w-full max-w-md relative pb-24" data-id="element-1">
        {/* SECTION 1: URGENCY BAR (Top of page, fixed) */}
        <div className="fixed top-0 left-0 right-0 z-50 bg-urgent flex justify-center shadow-lg" data-id="element-2">
          <div className="w-full max-w-md px-4 py-3 flex items-center justify-center gap-2" data-id="element-3">
            <span className="animate-blink text-lg leading-none" data-id="element-4">⚠️</span>
            <p className="text-white font-bold text-[13px] leading-tight text-center tracking-wide" data-id="element-5">
              ESTA OFERTA DESAPARECE CUANDO CERRÉS ESTA PÁGINA.
              <br className="hidden sm:block" data-id="element-6" /> NO SE VOLVERÁ A MOSTRAR.
            </p>
          </div>
        </div>

        {/* Spacer for fixed header */}
        <div className="h-16" data-id="element-7"></div>

        {/* SECTION 2: HERO / HOOK PRINCIPAL */}
        <section className="px-5 pt-8 pb-10 flex flex-col gap-6" data-id="element-8">
          <h1 className="text-white text-4xl sm:text-5xl font-black leading-[1.1] tracking-tight" data-id="element-9">
            ¡Tu compra está confirmada! 🎉
          </h1>

          <h2 className="text-sky-400 text-2xl font-extrabold leading-snug" data-id="element-10">
            Ya tenés tu pedido asegurado. Pero antes de irte, leé esto — te
            damos <span className="text-gold" data-id="element-11">acceso de por vida</span> a
            material nuevo en tendencia para vender en tu comercio.
          </h2>

          <p className="text-gray-200 text-lg leading-relaxed font-medium mt-2" data-id="element-12">
            Ya compraste el pack de la Scaloneta 2026. Excelente decisión. Pero
            pensá en esto: hoy es el Mundial, mañana puede ser otra moda, otra
            tendencia, otro boom viral.
            <br data-id="element-13" />
            <br data-id="element-14" />
            <span className="text-white font-bold" data-id="element-15">Pagás una sola vez</span> y
            automáticamente te voy a mandar a tu correo todos los productos{' '}
            <span className="text-gold font-black" data-id="element-16">
              LISTOS PARA IMPRIMIR Y VENDER
            </span>{' '}
            para que sigas haciendo plata en tu comercio, sin importar qué
            tendencia venga.
          </p>
        </section>

        {/* SECTION 4: LA SOLUCIÓN (El giro) */}
        <section className="mt-8 bg-gradient-to-b from-blue-950 via-blue-900/40 to-dark px-5 py-12 border-t border-blue-900/50" data-id="element-17">
          <div className="flex flex-col gap-6" data-id="element-18">
            <div className="text-5xl drop-shadow-[0_0_15px_rgba(212,175,55,0.5)]" data-id="element-19">
              🔑
            </div>

            <div className="self-start border border-gold text-gold font-bold text-xs px-3 py-1 rounded-full uppercase tracking-widest bg-gold/10" data-id="element-20">
              LA SOLUCIÓN
            </div>

            <h2 className="text-white text-3xl sm:text-4xl font-black leading-[1.15] tracking-tight" data-id="element-21">
              ¿Y si tuvieras un proveedor que te manda los productos en
              tendencia antes de que exploten?
            </h2>

            <p className="text-gray-200 text-xl leading-relaxed font-medium mt-2" data-id="element-22">
              Eso es exactamente lo que estamos ofreciéndote{' '}
              <span className="text-white font-black underline decoration-urgent decoration-4 underline-offset-4" data-id="element-23">
                HOY, y solo HOY
              </span>
              , antes de que cierres esta página.
            </p>
          </div>
        </section>

        {/* SECTION 5: HOTMART SALES FUNNEL */}
        <section className="px-5 py-10" data-id="element-24">
          <div id="hotmart-sales-funnel" data-id="element-25"></div>
        </section>
      </div>
    </div>;
}